import React, { useEffect, useState } from 'react'
import { Card, Form, Button, Row, Col, DatePicker, Spin, Table, Switch } from 'antd'
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage'
import BaseListing from 'src/BaseListings'
import WidgetBranchSelector from 'src/widgets/Selectors/WidgetBranchSelector'
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications'
import { wtApiCall, wtApiPostWithContentTypeHandling } from 'src/helpers/commons/ApiWrapper'
import WidgetSelector from 'src/widgets/Selectors/WidgetSelector'
import { wtFormatRoundedValue, wtRoundValue } from 'src/helpers/commons/utils'
import {
  SALE_ORDER_CURRENCY_SYMBOL,
  SALE_ORDER_STATUS_DROPDOWN_OPTIONS,
  SALE_ORDER_STATUS_NAME,
} from 'src/models/sale-orders'
import WidgetDepartmentSelector from 'src/widgets/Selectors/WidgetDepartmentSelector'
import WidgetProjectSelector from 'src/widgets/Selectors/WidgetProjectSelector'
import WidgetCustomerSelector from 'src/widgets/Selectors/WidgetCustomerSelector'
import style from './style.css'
import { useMasterDateTimeFormats } from 'src/helpers/commons/masterDateFormat'
import WidgetItemSelector from 'src/widgets/Selectors/WidgetItemSelector'
import WidgetItemBrandSelector from 'src/widgets/Selectors/WidgetItemBrandSelector'
import { useNavigate } from 'react-router-dom'
const SaleOrderDetailReport = () => {
  const Base = new BaseListing('sale_order_report')
  const { formatDate, formatDateTime } = useMasterDateTimeFormats()
  const [isLoading, setIsLoading] = useState(false)
  const [form] = Form.useForm()
  const [branchId, setBranchId] = useState(0)
  const [DepartmentId, setDepartmentId] = useState(0)
  const [branchName, setBranchName] = useState('')
  const [DepartmentName, setDepartmentName] = useState('')
  const [SoDData, setSaleOrderDetailReportData] = useState([])
  const branches = wtGetFromLocalStorage('branches')
  const [customers, setCustomers] = useState([])
  const [departments, setDepartments] = useState([])
  const [projects, setProjects] = useState([])
  const [Items, setItems] = useState([])
  const [Brands, setBrands] = useState([])
  const [ProjectId, setProjectId] = useState('')
  const [ItemId, setItemId] = useState('')
  const [ItemName, setItemName] = useState('')
  const [BrandId, setBrandId] = useState('')
  const [BrandName, setBrandName] = useState('')
  const [ProjectName, setProjectName] = useState('')
  const [searchMore, setSearchMore] = useState(false)
  const [dateRange, setDateRange] = useState([])
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)
  const [PartyName, setPartyName] = useState('')
  const [PartyId, setPartyId] = useState(null)
  const [Status, setStatus] = useState(null)
  const navigate = useNavigate()

  const changeValues = (key, val) => {
    setSaleOrderDetailReportData([])
    if (key === 'branch_id') {
      setBranchId(val.value)
      setBranchName(val.label)
    }
    if (key === 'department_id') {
      setDepartmentId(val.value)
      setDepartmentName(val.label)
    }
    if (key === 'project_id') {
      setProjectId(val)
      const selectedProject = projects.find((p) => p.value === val)
      setProjectName(selectedProject ? selectedProject.title : '')
    }
    if (key === 'date_range') {
      setDateRange(val)
    }
    if (key === 'type') {
      setVoucherType(val.value)
      setVoucherTypeName(val.label)
    }
    if (key === 'customer_id') {
      setPartyId(val)
      if (val === null) {
        setPartyName('')
      }
    }
    if (key === 'status') {
      setStatus(val.value)
    }

    if (key === 'item_id') {
      setItemId(val.value)
      setItemName(val.label)
    }
    if (key === 'brand_id') {
      setBrandId(val.value)
      setBrandName(val.label)
    }
  }


  const exportToExcel = () => {
    setIsLoading(true)
    wtApiPostWithContentTypeHandling('sale_order_detail_report/export', { data: SoDData })
    setIsLoading(false)
  }
  useEffect(() => {
    Base.dropdownData(
      'customers,departments,projects,items,item_brands',
      {},
      [setCustomers, setDepartments, setProjects, setItems, setBrands],
      1,
    )
  }, [])

  const getReportData = () => {
    if (dateRange.length < 2) {
      lzNotifyErrorMessageFromResult('Please select date range')
      return
    }
    const fromDate = dateRange[0]
    const toDate = dateRange[1]
    setIsLoading(true)
    wtApiCall(
      'reports/sale_order_detail_report',
      {
        branch_id: branchId,
        from_date: fromDate.format('YYYY-MM-DD'),
        to_date: toDate.format('YYYY-MM-DD'),
        party_id: PartyId,
        department_id: DepartmentId,
        status: Status,
        project_id: ProjectId,
        brand_id: BrandId,
        item_id: ItemId,
      },
      'get',
      (response) => {
        setSaleOrderDetailReportData(response.data)
        setIsLoading(false)
      },
      (error) => {
        lzNotifyErrorMessageFromResult(error)
        setIsLoading(false)
      },
    )
  }
  const columns = [
    {
      key: 'sr',
      title: 'SR',
      render: (text, record, index) => index + 1, // Adds Serial Number
      fixed: 'left',
      width: 50,
    },
    {
      key: 'code',
      title: 'SOD#',
      dataIndex: 'code',
      fixed: 'left',
      width: 90,
      render: (text, record) => (
        <span
          onClick={() =>
            window.open(`/sale_orders#view:${record.sale_order.id}`, '_blank')
          }
          style={{ color: 'blue', cursor: 'pointer', textDecoration: 'none' }}
        >
          {record.sale_order.code}
        </span>
      )
    },
    {
      key: 'sod_date',
      title: 'SOD Date',
      render: (text, record) => formatDate(record.sale_order.sod_date),
      fixed: 'left',
      width: 150,
    },
    {
      key: 'item_id',
      title: 'Item Name',
      dataIndex: 'item_name',
      // render: (text, record) => record.project.name,
      fixed: 'left',
      width: 150,
    },
    {
      key: 'item_unit_id',
      title: 'Item Unit',
      dataIndex: 'item_unit_id',
      render: (text, record) => (record.item_unit ? record.item_unit.name : ''),
      fixed: 'left',
      width: 150,
    },
    {
      key: 'item_brand_id',
      title: 'Item Brand',
      dataIndex: 'item_brand_id',
      render: (text, record) => record.item_brand.name,
      // fixed: 'left',
      // width: 180,
    },
    {
      key: 'quantity',
      title: 'Quantity',
      dataIndex: 'quantity',
      render: (quantity) => <span style={{ color: '' }}>{wtRoundValue(quantity)}</span>,
    },

    {
      key: 'unit_price',
      title: 'Unit Price',
      dataIndex: 'unit_price',
      render: (unit_price) => (
        <span style={{ color: 'blue' }}>
          {wtFormatRoundedValue(unit_price, SALE_ORDER_CURRENCY_SYMBOL, '', 3)}
        </span>
      ),
      width: 120,

    },
    {
      key: 'discount_amount',
      title: 'Discount Amount',
      dataIndex: 'discount_amount',
      width: 120,

      render: (discount_amount) =>
        wtFormatRoundedValue(discount_amount, SALE_ORDER_CURRENCY_SYMBOL, '', 3),
    },

    {
      key: 'tax_amount',
      title: 'Tax Amount',
      width: 120,
      dataIndex: 'tax_amount',
      render: (tax_amount) => wtFormatRoundedValue(tax_amount, SALE_ORDER_CURRENCY_SYMBOL, '', 3),
    },
    {
      key: 'net_total',
      title: 'Net Total',
      dataIndex: 'net_total',
      // fixed: 'right', // Last column fixed
      width: 150,
      render: (net_total) => (
        <span style={{ color: 'blue' }}>
          {wtFormatRoundedValue(net_total, SALE_ORDER_CURRENCY_SYMBOL, '', 3)}
        </span>
      ),
    },
    {
      key: 'delivered_quantity',
      title: 'Delivered Quantity',
      dataIndex: 'delivered_quantity',
      render: (delivered_quantity) => (
        <span style={{ color: 'blue' }}>{wtFormatRoundedValue(delivered_quantity, '', '', 3)}</span>
      ),
    },
    {
      key: 'record',
      title: 'Balance',
      dataIndex: 'record',
      render: (text, record) => (
        <span style={{ color: 'blue' }}>
          {wtFormatRoundedValue(record.quantity - record.delivered_quantity, '', '', 3)}
        </span>
      ),
    },
    {
      key: 'unit_cost',
      title: 'Unit Cost',
      dataIndex: 'unit_cost',
      // fixed: 'right', // Last column fixed
      width: 150,
      render: (unit_cost) => (
        <span style={{ color: 'blue' }}>
          {wtFormatRoundedValue(unit_cost, SALE_ORDER_CURRENCY_SYMBOL, '', 3)}
        </span>
      ),
    },
    {
      key: 'total_cost',
      title: 'Total Cost',
      dataIndex: 'total_cost',
      // fixed: 'right', // Last column fixed
      width: 150,
      render: (total_cost) => (
        <span style={{ color: 'blue' }}>
          {wtFormatRoundedValue(total_cost, SALE_ORDER_CURRENCY_SYMBOL, '', 3)}
        </span>
      ),
    },
    {
      key: 'name',
      title: 'Branch',
      render: (text, record) => record.branch.name,
    },
    {
      key: 'name',
      title: 'Department',
      render: (text, record) => record.sale_order.department.name,
    },
    {
      key: 'name',
      title: 'Customer',
      render: (text, record) => record.sale_order.party.name,
    },

    {
      key: 'created_at',
      title: 'Creation Date',
      dataIndex: 'created_at',
      render: (created_at) => <span>{formatDateTime(created_at)}</span>,
    },
    {
      key: 'created_by_id',
      title: 'Creation By',
      dataIndex: 'created_by_id',
      render: (text, record) => record.created_by.name,
    },
  ]
  return (
    <div
      className="container-fluid"
      style={{
        padding: '1em',
        backgroundColor: 'white',
        minHeight: '100vh',
        fontFamily: 'Helvetica',
      }}
    >
      <Form
        layout={'vertical'}
        form={form}
        onFinish={getReportData}
        style={{ maxWidth: '100%', margin: '0 auto' }}
      >
        <Card
          style={{ width: '100%' }}
          title={
            <span style={{ fontSize: '26px', marginLeft: '45%' }}>Sale Order Detail Report</span>
          }
        >
          <Row gutter={[24, 24]}>
            <Col xs={15} sm={10} md={4}>
              <label>Date Range: *</label>
              <DatePicker.RangePicker
                onChange={(value) => {
                  setDateRange(value)
                  if (value && value.length === 2) {
                    setFromDate(value[0].format('YYYY-MM-DD'))
                    setToDate(value[1].format('YYYY-MM-DD'))
                  }
                }}
                style={{ width: '100%', height: 35 }}
                value={dateRange}
              />
            </Col>
            <Col xs={15} sm={10} md={4}>
              <label>Department:</label>
              <WidgetDepartmentSelector
                value={DepartmentId}
                displayValue={DepartmentName}
                departments={departments}
                placeholder="Select Department"
                onChange={(values) => changeValues('department_id', values)}
                showCloudIcon={false}
              />
            </Col>
            <Col xs={15} sm={10} md={4}>
              <label>Branch:</label>
              <WidgetBranchSelector
                value={branchId}
                displayValue={branchName}
                branches={branches}
                placeholder="Select Branch"
                onChange={(values) => changeValues('branch_id', values)}
                showCloudIcon={false}
              />
            </Col>
            <Col xs={15} sm={10} md={4}>
              <label>Customer</label>
              <WidgetCustomerSelector
                onChange={(value) => changeValues('customer_id', value)}
                customers={customers}
                displayValue={PartyName}
                value={PartyId}
                reloadDropdownData={() => reloadParties()}
              />
            </Col>
            <Col xs={12} sm={8} md={8}>
              <Button
                style={{ marginTop: 30, marginRight: 5, color: '#fff', backgroundColor: '#E29C06' }}
                onClick={() => setSearchMore(!searchMore)}
                disabled={isLoading ? true : false}
              >
                {searchMore ? 'Less...' : 'More...'}
              </Button>
              <Button
                style={{ marginTop: 30, marginRight: 5 }}
                type="primary"
                htmlType="submit"
                disabled={isLoading ? true : false}
              >
                Search
              </Button>
              <Button
                style={{ marginTop: 30, backgroundColor: '#4BB543', color: '#fff' }}
                onClick={exportToExcel}
                disabled={isLoading ? true : false}
              >
                Export
              </Button>
            </Col>
          </Row>
          {searchMore && (
            <>
              <br></br>
              <Row gutter={[24, 24]}>
                <Col xs={15} sm={10} md={5}>
                  <label>Status:</label>
                  <WidgetSelector
                    options={SALE_ORDER_STATUS_DROPDOWN_OPTIONS}
                    selectedValue={Status}
                    displayValue={SALE_ORDER_STATUS_NAME[Status]}
                    onChange={(value) => changeValues('status', value)}
                  />
                </Col>
                <Col xs={15} sm={10} md={5}>
                  <label>Project:</label>
                  <WidgetProjectSelector
                    onChange={(value) => changeValues('project_id', value)}
                    data={projects} // <-- Use the formatted treeData here
                    value={ProjectId}
                    displayValue={ProjectName}
                    height={35}
                    reloadDropdownData={() => Base.dropdownData('projects', {}, [setProjects], 1)}
                  />
                </Col>

                <Col xs={15} sm={10} md={5}>
                  <label>Item Name:</label>
                  <WidgetItemSelector
                    items={Items}
                    onChange={(value) => changeValues('item_id', value)}
                    displayValue={ItemName}
                    reloadDropdownData={() => Base.dropdownData('items', {}, [setItems], 1)}
                    placeHolder={"Select Item"}
                    value={ItemId}
                  // size={'sm'}
                  />
                </Col>

                <Col xs={15} sm={10} md={5}>
                  <label>Item Brand:</label>

                  <WidgetItemBrandSelector
                    item_brands={Brands}
                    onChange={(value) => changeValues('brand_id', value)}
                    displayValue={BrandName}
                    reloadDropdownData={() => Base.dropdownData('item_brands', {}, [setItems], 1)}
                    placeHolder={"Select Brand"}
                    value={BrandId}
                  // size={'sm'}
                  />
                </Col>
              </Row>
            </>
          )}
        </Card>
      </Form>
      <Card style={{ marginTop: 30 }}>
        <Spin spinning={isLoading}>
          <Table
            columns={columns}
            dataSource={SoDData}
            rowKey="id"
            pagination={false}
            bordered
            scroll={{ x: 2500, y: 500 }}
          />
        </Spin>
      </Card>
    </div>
  )
}
export default SaleOrderDetailReport
